import { render, staticRenderFns } from "./BatchAdd.vue?vue&type=template&id=1ea522d1&scoped=true"
import script from "./BatchAdd.vue?vue&type=script&lang=js"
export * from "./BatchAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea522d1",
  null
  
)

export default component.exports